<template>
	<div id="app">
		<NetworkError v-if="required && !web_show" @onRefresh="handleRefresh"></NetworkError>
		<template v-if="required && web_show">
			<router-view></router-view>
		</template>
	</div>
</template>

<script>
import Login from './assets/js/login.js';
import Api from './api/index.js';
import { mapState, mapMutations } from 'vuex';
export default {
	created() {
		!this.whetherPc() && location.replace('http://mcloud.uflycloud.com/');
		Login.init();
		var _isLogin = Login.checkLogin(),
			_path = this.$route.path;
		if (!_isLogin && _path != '/login') {
			this.$router.replace({
				path: '/login'
			});
		}
		if (_isLogin && _path == '/login') {
			this.$router.replace({
				path: '/index'
			});
		}
		if (_isLogin) {
			this.findAuthInfo();
		} else {
			this.required = true;
			this.web_show = true;
		}
	},
	mounted() {
		document.getElementById('window_loading').remove();
	},
	data() {
		return {
			required: false,
			web_show: false
		};
	},
	computed: {
		...mapState(['loginInfo', 'authInfo'])
	},
	methods: {
		// 刷新
		handleRefresh() {
			this.findAuthInfo();
		},
		// 判断是否是pc端
		whetherPc() {
			var userAgentInfo = navigator.userAgent;
			var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod', 'pad', 'pod', 'phone', 'ios'];
			var flag = true;
			for (var v = 0; v < Agents.length; v++) {
				if (userAgentInfo.indexOf(Agents[v]) > 0) {
					flag = false;
					break;
				}
			}
			return flag;
		},
		// 获取登录者信息
		findAuthInfo() {
			const that = this;
			that.Loading = that.$loading({
				lock: true,
				text: '加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			if (JSON.stringify(that.authInfo) == '{}') {
				var requestData = {
					uCode: that.loginInfo.code,
					type: 'b'
				};
				Api.findUserInfo(requestData).then(
					(rt) => {
						if (rt.data.success) {
							that.setAuthInfo(rt.data.data);
							that.findProductType();
						} else {
							that.required = true;
							that.Loading.close();
							that.$message.error(rt.data.message);
						}
					},
					(e) => {
						that.required = true;
						that.Loading.close();
						that.$message.error(e.message);
					}
				);
			} else {
				that.findProductType();
			}
		},
		// 获取产品类型
		findProductType() {
			const that = this;
			var _requestData = {};
			Api.findProductType(_requestData).then(
				(res) => {
					if (res.data.success) {
						let products = [];
						let mission = [];
						let mission_ids = [];
						res.data.data.forEach((v) => {
							var _isBe = false;
							products.forEach((fv) => {
								if (fv.id == v.productId) {
									_isBe = true;
									v.missionId &&
										fv.child.push({
											missionId: v.missionId,
											missionName: v.missionName
										});
								}
							});
							!_isBe &&products.push({
									id: v.productId,
									name: v.productName,
									child: v.missionId? [{
													missionId: v.missionId,
													missionName: v.missionName
												}]: []
								});
							mission_ids.indexOf(v.missionId) == -1 &&
								mission.push({
									id: v.missionId,
									name: v.missionName
								});
							mission_ids.indexOf(v.missionId) == -1 && mission_ids.push(v.missionId);
						});
						// console.log(_list);
						that.setAllProduct(products);
						that.setMission(mission);
						that.findAuthProduct();
					} else {
						that.required = true;
						that.Loading.close();
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.required = true;
					that.Loading.close();
					that.$message.error(e.message);
				}
			);
		},
		// 获取登录者产品
		findAuthProduct() {
			const that = this;
			var _requestData = {};
			Api.findAuthProduct(_requestData).then(
				(res) => {
					if (res.data.success) {
						var _list = [];
						res.data.data &&
							res.data.data.forEach((v) => {
								_list.push({
									id: v.productId,
									name: v.productName
								});
							});
						// console.log(_list);
						that.setAuthProduct(_list);
						that.findAllDisease();
					} else {
						that.required = true;
						that.Loading.close();
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.required = true;
					that.Loading.close();
					that.$message.error(e.message);
				}
			);
		},
		// 获取病理类型
		findAllDisease() {
			const that = this;
			var _requestData = {};
			Api.findAllDisease(_requestData).then(
				(res) => {
					if (res.data.success) {
						var _list = [];
						res.data.data.forEach((v) => {
							_list.push({
								id: v.uid,
								name: v.uname
							});
						});
						that.setAllDisease(_list);
						that.findPermission();
					} else {
						that.required = true;
						that.Loading.close();
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.required = true;
					that.Loading.close();
					that.$message.error(e.message);
				}
			);
		},
		// 获取权限
		findPermission() {
			const that = this;
			Api.findPermission().then(
				(res) => {
					if (res.data.success) {
						let res_list = res.data.data || [];
						let list = [];
						res_list.forEach((v) => {
							list.push({
								id: v.privilegeId,
								name: v.privilegeName,
								url: v.privilegeUrl
							});
						});
						that.setAllPermission(list);
						that.findAppManager();
					} else {
						that.required = true;
						that.Loading.close();
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.required = true;
					that.Loading.close();
					that.$message.error(e.message);
				}
			);
		},
		// 获取app商务经理
		findAppManager() {
			const that = this;
			Api.findAppManager().then(
				(res) => {
					if (res.data.success) {
						let res_list = res.data.data || [];
						let list = [];
						res_list.forEach((v) => {
							list.push({
								id: v.uId,
								name: v.uName,
								mobile: v.uPhone
							});
						});
						that.setAppManager(list);
						that.findOrganizations();
					} else {
						that.required = true;
						that.Loading.close();
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.required = true;
					that.Loading.close();
					that.$message.error(e.message);
				}
			);
		},
		// 获取机构
		findOrganizations() {
			const that = this;
			Api.findOrganizations().then(
				(res) => {
					if (res.data.success) {
						let res_list = res.data.data || [];
						let list = [];
						res_list.forEach((v) => {
							list.push({
								id: v.uId,
								name: v.uName
							});
						});
						that.setAllOrganization(list);
						that.findAppArticlePublisher();
					} else {
						that.required = true;
						that.Loading.close();
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.required = true;
					that.Loading.close();
					that.$message.error(e.message);
				}
			);
		},
		// 获取app文章发布人
		findAppArticlePublisher() {
			const that = this;
			Api.findAppArticlePublisher().then(
				(res) => {
					if (res.data.success) {
						let res_list = res.data.data || [];
						let list = [];
						res_list.forEach((v) => {
							list.push({
								id: v.uId,
								name: v.uName,
								oid: v.uEnterpriseId
							});
						});
						that.setAppArticlePublisher(list);
						that.findTrainingProductForApp();
					} else {
						that.required = true;
						that.Loading.close();
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.required = true;
					that.Loading.close();
					that.$message.error(e.message);
				}
			);
		},
		// 获取app训练产品列表
		findTrainingProductForApp() {
			const that = this;
			Api.findTrainingProductForAppAndMall({ typeChannel: 1 }).then(
				(res) => {
					if (res.data.success) {
						let res_list = res.data.data || [];
						let list = [];
						res_list.forEach((v) => {
							list.push({
								id: v.productId,
								name: v.productName
							});
						});
						that.setAppTrainingProduct(list);
						that.findTrainingProductForMall();
					} else {
						that.required = true;
						that.Loading.close();
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.required = true;
					that.Loading.close();
					that.$message.error(e.message);
				}
			);
		},
		// 获取商城训练产品列表
		findTrainingProductForMall() {
			const that = this;
			Api.findTrainingProductForAppAndMall({ typeChannel: 2 }).then(
				(res) => {
					if (res.data.success) {
						let res_list = res.data.data || [];
						let list = [];
						res_list.forEach((v) => {
							list.push({
								id: v.productId,
								name: v.productName
							});
						});
						that.setMallTrainingProduct(list);
						that.Loading.close();
						that.required = true;
						that.web_show = true;
					} else {
						that.required = true;
						that.Loading.close();
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.required = true;
					that.Loading.close();
					that.$message.error(e.message);
				}
			);
		},
		...mapMutations({
			setAuthInfo: 'setAuthInfo',
			setAllProduct: 'setAllProduct',
			setMission: 'setMission',
			setAuthProduct: 'setAuthProduct',
			setAllDisease: 'setAllDisease',
			setAllPermission: 'setAllPermission',
			setAllOrganization: 'setAllOrganization',
			setAppManager: 'setAppManager',
			setAppArticlePublisher: 'setAppArticlePublisher',
			setAppTrainingProduct: 'setAppTrainingProduct',
			setMallTrainingProduct: 'setMallTrainingProduct'
		})
	}
};
</script>

<style>
/*css #30a5ff 初始化 */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video,
input,
textarea,
button,
select {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
	border: none;
	outline: none;
	word-break: break-all;
	background: transparent;
}
body {
	background: #fff;
	overflow: hidden;
	font-family: '思源黑体', 'Helvetica Neue', Helvetica, Arial, sans-serif;
	font-weight: normal;
	font-size: 14px;
	color: #333;
	line-height: 24px;
}
h1,
h2,
h3,
h4,
h5,
h6,
input,
button,
textarea,
th,
a,
select {
	font-size: 14px;
	color: #333;
	font-weight: normal;
}
fieldset,
img,
input,
button {
	border: none;
	padding: 0;
	margin: 0;
	outline-style: none;
}
ul,
ol {
	list-style: none;
}
input {
	padding-top: 0;
	padding-bottom: 0;
}
select,
input {
	vertical-align: middle;
}
select,
input,
textarea {
	font-size: 12px;
	margin: 0;
	border: none;
	outline: none;
}
textarea {
	outline: none;
	resize: none;
}

/*防止拖动*/
img {
	border: 0;
	vertical-align: middle;
}
/*  去掉图片低测默认的3像素空白缝隙*/
table {
	border-collapse: collapse;
	border-spacing: 0;
}
a {
	text-decoration: none;
}
a:hover,
button:hover {
	cursor: pointer;
}
s,
i,
em {
	font-style: normal;
	text-decoration: none;
}

.clear_both:after {
	content: '';
	display: block;
	height: 0;
	clear: both;
	visibility: hidden;
}

/* .container{ display: block;position: absolute;min-width: 1200px;top: 0;left: 0;right: 0;bottom: 0;overflow-y: auto;overflow-x: hidden; } */

.container {
	position: relative;
	min-width: 1200px;
	height: 100vh;
	overflow-y: auto;
	overflow-x: hidden;
}

.border_t {
	border-top: 1px solid #ccc;
}
.border_r {
	border-right: 1px solid #ccc;
}
.border_b {
	border-bottom: 1px solid #ccc;
}
.border_l {
	border-left: 1px solid #ccc;
}

.border_float_t::before {
	content: '';
	display: block;
	position: absolute;
	width: 100%;
	height: 1px;
	top: 0;
	left: 0;
	background: #ccc;
}
.border_float_r::after {
	content: '';
	display: block;
	position: absolute;
	width: 1px;
	height: 100%;
	top: 0;
	right: 0;
	background: #ccc;
}
.border_float_b::after {
	content: '';
	display: block;
	position: absolute;
	width: 100%;
	height: 1px;
	bottom: 0;
	left: 0;
	background: #ccc;
}
.border_float_l::before {
	content: '';
	display: block;
	position: absolute;
	width: 1px;
	height: 100%;
	top: 0;
	left: 0;
	background: #ccc;
}

.bg_theme {
	background-color: #409eff !important;
}
.bg_success {
	background-color: #67c23a !important;
}
.bg_warn {
	background-color: #e6a23c !important;
}
.bg_danger {
	background-color: #f56c6c !important;
}
.bg_info {
	background-color: #909399 !important;
}
</style>
